export const ConvertDollarsToCents = (value: string | number) => {
  const float = parseFloat(value as string);
  return parseInt((float * 100).toFixed(0));
};

export const ConvertCentsToDollars = (
  value: string | number,
  dropCentsIfWhole = false
) => {
  const int = parseInt(value as string);
  const float = int / 100;
  return dropCentsIfWhole && float % 1 === 0
    ? float.toFixed(0)
    : float.toFixed(2);
};

export type FormatCurrencyOptions = {
  decimalPlaces?: number;
  fallback?: string;
  isCents?: boolean;
};

const normalizeNumericValue = (value: string | number) => {
  if (typeof value === "string") {
    const trimmedValue = value.trim();
    if (trimmedValue === "") {
      return Number.NaN;
    }
    return Number(trimmedValue);
  }

  return value;
};

export const formatCurrency = (
  value: string | number | null | undefined,
  currencySymbol: string,
  {
    decimalPlaces = 2,
    fallback = "",
    isCents = true,
  }: FormatCurrencyOptions = {}
) => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const numericValue = normalizeNumericValue(value);

  if (Number.isNaN(numericValue)) {
    return fallback;
  }

  const isNegative = numericValue < 0;
  const absoluteValue = Math.abs(numericValue);

  const formattedValue = isCents
    ? (Math.trunc(absoluteValue) / 100).toFixed(decimalPlaces)
    : absoluteValue.toFixed(decimalPlaces);

  return `${isNegative ? "-" : ""}${currencySymbol}${formattedValue}`;
};

export const formatCurrencyRange = (
  min: string | number | null | undefined,
  max: string | number | null | undefined,
  currencySymbol: string,
  options?: FormatCurrencyOptions
) => {
  const formattedMin = formatCurrency(min, currencySymbol, options);
  const formattedMax = formatCurrency(max, currencySymbol, options);

  if (!formattedMin && !formattedMax) {
    return options?.fallback ?? "";
  }

  if (!formattedMin) {
    return formattedMax;
  }

  if (!formattedMax) {
    return formattedMin;
  }

  if (formattedMin === formattedMax) {
    return formattedMin;
  }

  return `${formattedMin} - ${formattedMax}`;
};

export const ConvertPercentToDecimal = (value: string | number) => {
  const float = parseFloat(value as string);
  return float / 100;
};

export const ConvertDecimalToPercent = (value: string | number) => {
  const float = parseFloat(value as string);
  return (float * 100).toFixed(2);
};
